<template>
  <div class="hello" style="background-color: #fff; min-height: 100vh">
    <div style="padding: 20px 20px">
      <!-- 顶部图片 -->
      <van-image
        width="100%"
        radius="10px"
        :src="require('../assets/picture/ztjz.png')"
      />
      <!-- 年份下拉表 -->
      <div>
        <van-row type="flex" justify="end">
          <van-col span="4">
            <select
              v-model="selectYear"
              @change="selectChange($event)"
              class="selectClass"
            >
              <option
                v-for="(item, index) in selectYearsColumns"
                :key="index"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </van-col>
        </van-row>
      </div>
      <!-- 标题介绍 -->
      <h3 style="text-align: initial; color: #000; font-weight: 700">
        <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
      </h3>

      <!-- 月份 -->
      <div class="cardClass" style="flex-wrap: wrap">
        <div
          v-for="(item, i) in monthList"
          :key="i"
          class="monthClass"
          @click="OpenDetail(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- 表格图表弹窗 -->
    <van-dialog
      v-model="showZtjz"
      :showConfirmButton="false"
      style="width: 95%; height: calc(100% - 90px)"
    >
      <div class="vanDialogClass">
        <!-- 最顶部标题 -->
        <h3 style="text-align: initial; color: #000">
          <span style="color: #d5a6cc">▋</span> {{ dataTitle }}
        </h3>
        <!-- 基本情况展示 -->
        <div class="conditionClass">
          <div>
            <div class="conditionBox1">
              重点工作任务书及清单化项目 <span>{{ sumVal.xmzs }}</span> 项
            </div>
            <div class="conditionBox2 flex-around">
              <div @click="detailAllFn('zc')">
                <p style="color: green">{{ sumVal.zc }}</p>
                <p>正常</p>
              </div>
              <div @click="detailAllFn('bj')">
                <p style="color: #666">{{ sumVal.bj }}</p>
                <p>办结</p>
              </div>
              <div @click="detailAllFn('cq')">
                <p style="color: skyblue">{{ sumVal.cq }}</p>
                <p>超前</p>
              </div>
              <div @click="detailAllFn('zh')">
                <p style="color: red">{{ sumVal.zh }}</p>
                <p>滞后</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格 -->
        <div class="tableBoxClass">
          <div class="tableTitleClass">{{ tableConfigObj.title }}</div>
          <div class="tableCls">
            <header>
              <div>
                <span
                  v-for="(item, index) in tableConfigObj.columns"
                  :key="index"
                >
                  {{ item.text }}
                </span>
              </div>
            </header>
            <div class="tableContentCls">
              <content>
                <div v-for="(item2, index2) in tableDataList" :key="index2">
                  <span
                    v-for="(item3, index3) in tableConfigObj.columns.filter(
                      (x) => x.key
                    )"
                    :key="index3 + 's1'"
                    @click="detailFn(item3, item2)"
                  >
                    {{ item2[item3.key] }}
                  </span>
                </div>
              </content>
            </div>
          </div>
        </div>

        <div
          style="height: 20px; color: darkgoldenrod; text-align: center"
          v-if="showZtjz && tableDataList.length == 0"
        >
          暂无数据
        </div>

        <div class="closeBtnClass" @click="CloseDetail">关闭</div>
      </div>
    </van-dialog>

    <div style="height: 100px"></div>
  </div>
</template>

<script>
import Table from './custom/Table.vue'
import { getDict } from '../api/zdqd.js'
import { deepClone } from '../utils/deepClone'
import { ApiGetZTJZ } from '../api/zsyz'
export default {
  name: 'ztzj',
  components: { Table },
  computed: {
    sumVal() {
      return this.tableDataList.reduce(
        (a, b) => {
          a.xmzs += b.xmzs
          a.zc += b.zc
          a.zh += b.zh
          a.cq += b.cq
          a.bj += b.bj
          return a
        },
        { xmzs: 0, zc: 0, zh: 0, cq: 0, bj: 0 }
      )
    },
  },
  data() {
    return {
      // 后台获取的年份列表
      selectYearsColumns: [],
      // 获取今年
      selectYear: process.env.VUE_SELECT_YEAR,
      // selectYear: new Date().getFullYear(),
      // 当前月份
      currentMonth: new Date().getMonth() + 1,
      // 是否显示背景暂无数据
      showZtjz: false,
      // 顶部标题数据
      dataTitle: '"六促六优"专项行动总体进展情况',
      zc: '',

      // 月份
      monthList: [
        { label: '1月', value: 1 },
        { label: '2月', value: 2 },
        { label: '3月', value: 3 },
        { label: '4月', value: 4 },
        { label: '5月', value: 5 },
        { label: '6月', value: 6 },
        { label: '7月', value: 7 },
        { label: '8月', value: 8 },
        { label: '9月', value: 9 },
        { label: '10月', value: 10 },
        { label: '11月', value: 11 },
        { label: '12月', value: 12 },
      ],
      // 传给表格的数据
      tableConfigObj: {
        columns: [
          { text: '协调小组名称', key: 'xtxz' },
          { text: '项目总数', key: 'xmzs' },
          { text: '正常', key: 'zc' },
          { text: '办结', key: 'bj' },
          { text: '超前', key: 'cq' },
          { text: '滞后', key: 'zh' },
        ],
        title: '',
      },
      // 传给表格的数据
      tableDataList: [],
      clickMonth: 1,
    }
  },
  created() {
    // 通过后台配置的字典，拿到年份
    getDict('selectyear_list').then((res) => {
      res.data.content.forEach((x) => {
        this.selectYearsColumns.push(x.label)
      })
    })
  },
  methods: {
    async init(selectYear, currentMonth) {
      const res = await ApiGetZTJZ({
        year: selectYear,
        month: currentMonth,
      })
      this.tableDataList = res.data.data
      this.clickMonth = res.data.month
    },
    selectChange(e) {
      this.selectYear = e.target.value
    },

    async OpenDetail(value) {
      this.currentMonth = value
      this.init(this.selectYear, this.currentMonth)
      this.showZtjz = true
      this.tableConfigObj.title = `${this.selectYear}年${this.currentMonth}月`
    },
    CloseDetail() {
      this.showZtjz = false
    },
    detailFn(value, value2) {
      // if (this.currentMonth !== this.clickMonth) return
      var zt = 0
      switch (value.key) {
        case 'zh':
          zt = 1
          break
        case 'zc':
          zt = 2
          break
        case 'cq':
          zt = 3
          break
        case 'bj':
          zt = 4
          break
      }
      var type = null
      var name = ''
      switch (value2.xtxz) {
        case '项目争优协调小组':
          type = 2
          name = '项目提速'
          break
        case '治理争优协调小组':
          type = 5
          name = '治理破难'
          break
        case '产业争优协调小组':
          type = 1
          name = '产业升级'
          break
        case '改革争优协调小组':
          type = 3
          name = '改革创新'
          break
        case '共富争优协调小组':
          type = 4
          name = '共富先行'
          break
        case '党建争优协调小组':
          type = 6
          name = '党建引领'
          break
      }
      this.$router.push({
        path: '/projectlist',
        query: {
          type,
          zt,
          name,
          selectYear: this.selectYear,
        },
      })
    },
    detailAllFn(type) {
      // if (this.currentMonth !== this.clickMonth) return
      switch (type) {
        case 'zc':
          this.$router.push({
            path: '/projectlist',
            query: {
              isAll: 'all',
              zt: 2,
              selectYear: this.selectYear,
            },
          })
          break
        case 'zh':
          this.$router.push({
            path: '/projectlist',
            query: {
              isAll: 'all',
              zt: 1,
              selectYear: this.selectYear,
            },
          })
          break
        case 'cq':
          this.$router.push({
            path: '/projectlist',
            query: {
              isAll: 'all',
              zt: 3,
              selectYear: this.selectYear,
            },
          })
          break
        case 'bj':
          this.$router.push({
            path: '/projectlist',
            query: {
              isAll: 'all',
              zt: 4,
              selectYear: this.selectYear,
            },
          })
          break
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.monthClass {
  background-color: #d5a6cc;
  border-radius: 10px;
  width: 70px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  margin: 5px;
}

.vanDialogClass {
  text-align: initial;
  padding: 25px 20px;
  height: 100%;
}
.conditionClass {
  width: 100%;
}
.conditionClass h4 {
  text-align: initial;
  color: #999;
}
.conditionClass > div {
  width: 100%;
  border: 2px solid #d4a6cb;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 10px;
}
.conditionClass .conditionBox1 {
  background-color: #d4a6cb;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  color: #fff;
  font-size: 14px;
}
.conditionClass .conditionBox1 span {
  font-size: 25px;
  padding: 0 4px;
}
.conditionClass .conditionBox2 div {
  text-align: center;
}
.conditionClass .conditionBox2 div p:nth-child(1) {
  font-size: 20px;
  font-weight: 700;
}
.conditionClass .conditionBox2 div p:nth-child(2) {
  font-size: 12px;
  color: #999;
}
.closeBtnClass {
  position: absolute;
  bottom: 20px;
  left: 40px;
  width: 80%;
  height: 45px;
  line-height: 45px;
  background-color: #d4a6cb;
  text-align: center;
  border-radius: 30px;
  color: #fff;
  letter-spacing: 16px;
}

.selectClass {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #c4c8cf;
  padding: 4px 0px 4px 0px;
}
.tableBoxClass {
  margin-top: 20px;
  color: #000;
  height: 100%;
}
.tableTitleClass {
  width: 100%;
  background-color: #e1f0ed;
  font-weight: 700;
  text-align: center;
  color: #000;
  border-radius: 10px 10px 0 0;
  padding: 5px 0;
}
.tableCls {
  font-size: 12px;
  font-weight: 700;
  height: 100%;
}
.tableContentCls {
  overflow: auto;
  height: calc(100% - 350px);
}
.tableBoxClass header div,
.tableBoxClass content div {
  width: 100%;
  display: flex;
}

.tableBoxClass header div span,
.tableBoxClass content div span {
  border: 1px solid #e3eef7;
  width: calc(100% / 6);
  word-wrap: break-word;
  word-break: break-all;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}
.tableBoxClass header div span:nth-child(1),
.tableBoxClass content div span:nth-child(1) {
  width: 100px;
}
.van-dialog >>> .van-dialog__content {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ztjz.vue